import BindWechatView from './BindWechatView'
export default BindWechatView;